import { useWorkspaceDetail } from '@/features/workspace/api';

export interface TrialStatus {
  isTrial: boolean;
  daysLeft: number | null;
  expired: boolean;
}

export function useTrialStatus(workspaceId: string | null): TrialStatus {
  const { data } = useWorkspaceDetail(workspaceId);
  if (!data || data.plan !== 'trial' || !data.trialEndsAt) {
    return { isTrial: false, daysLeft: null, expired: false };
  }
  const daysLeft = Math.ceil((new Date(data.trialEndsAt).getTime() - Date.now()) / (24 * 60 * 60 * 1000));
  return { isTrial: true, daysLeft, expired: daysLeft <= 0 };
}
